<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <base-material-card
      inline
      icon="mdi-map-marker"
      title="Radio access function"
    >

      <data-table
        :fetch-from="fetchForm"
        :fields="fields"
      >
        <template
          slot="active_candidate"
          slot-scope="slotData"
        >
          <template v-if="slotData.rowData.site">
            {{ slotData.rowData.site.active_candidate|formatBool|noDataAvailable }}
          </template>
          <template v-if="!slotData.rowData.site">
            /
          </template>
        </template>
        <template
          slot="actions"
          slot-scope="slotData"
        >
          <v-btn
            x-small
            color="primary"
            v-if="slotData.rowData.site && slotData.rowData.site.site_id"
            @click="openSite(slotData.rowData.site.id, slotData.rowData.SectorName, slotData.rowData.Cellname)"
          >Show</v-btn>
        </template>

      </data-table>
    </base-material-card>
  </v-container>
</template>

<script>
  import Card from '@/components/base/Card'
  import EmptySpace from '@/components/EmptySpace'
  import DataTable from '@/components/DataTable'
  import RadioAccessService from '@/services/radio-access'
  export default {
    name: 'Cells',
    components: { DataTable, EmptySpace, Card },
    data: function () {
      return {
        fields: [
          {
            name: 'site.function_id',
            title: 'Function id',
          },
          {
            name: 'site.t2_site_id',
            title: 'Location id',
          },
          {
            name: 'function_type',
            title: 'Function type',
          },
          {
            name: 'status',
            title: 'Status',
          },
          {
            name: 'technology',
            title: 'Technology',
          },
          {
            name: '__slot:active_candidate',
            title: 'Active candidate',
          },
          {
            name: 'Cellname',
            title: 'Cell name',
          },
          {
            name: 'cell_id',
            title: 'Cell ID',
          },
          {
            name: 'CellType',
            title: 'Cell type',
          },
          {
            name: 'BAND',
            title: 'Band',
          },
          {
            name: 'FlagStatus',
            title: 'Status',
          },
          {
            name: 'predmodel',
            title: 'Propagation model',
          },
          {
            name: 'OperationalDate',
            title: 'Active Date',
          },
          {
            name: '__slot:actions',
            title: 'Actions',
          },
        ],
      }
    },

    computed: {
    },

    methods: {
      fetchForm (urls, options) {
        const ns = new RadioAccessService()
        return ns.list(options.params)
      },
      openSite (siteId, sectorId, cellId) {
        let sector = sectorId
        if (sector[0] !== 'H') {
          sector = 'H' + sector
        }
        window.open('/#/sites/' + siteId + '/view/sector/' + sector + '/cell/' + cellId, '_blank')
      },
    },
  }
</script>
